import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { SearchParams } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";
import { routes } from "schemas/routes";

import { trackEvent } from "utils/tracking";

import { InstagramOnboardingOptions } from "../schema";

interface Props {
  checkoutVaPlan: () => void;
}

const InstagramOnboardingPreference = ({ checkoutVaPlan }: Props) => {
  const { currentOrg } = useContext(OrganizationUserContext);

  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [option, setOption] = useState<InstagramOnboardingOptions | null>(null);

  const navigate = useNavigate();

  const handleNext = () => {
    trackEvent("Onboarding Form - Next Button Pressed", {
      page: "preferencePage",
      route: location.pathname,
      option,
    });
    searchParams.set(SearchParams.OPTION, option || "");
    setSearchParams(searchParams);
    const updatedParamsString = searchParams.toString();
    if (currentOrg?.id) {
      if (option === InstagramOnboardingOptions.do_it_myself) {
        navigate(`/${routes.onboardingInfluencer}?${updatedParamsString}`);
      } else {
        checkoutVaPlan();
      }
    } else {
      navigate(`/${routes.signUpInstagramOnboarding}?${updatedParamsString}`);
    }
  };

  useEffect(() => {
    if (searchParams.get("option") && !option) {
      setOption(searchParams.get("option") as InstagramOnboardingOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams.get("option")]);

  return (
    <>
      <Typography variant="h6">
        <strong>Prefer to pitch on your own or have Bento handle it?</strong>
      </Typography>

      <FormControl>
        <RadioGroup
          onChange={(e: CustomEvent) => {
            setOption(e.target.value as InstagramOnboardingOptions);
          }}
          value={option || ""}
        >
          <FormControlLabel
            value={InstagramOnboardingOptions.done_for_you}
            control={<Radio />}
            label={
              <Typography component="div">
                Done for You{" "}
                <Typography
                  component="span"
                  color="textSecondary"
                  variant="body2"
                >
                  (starts at $50/month)
                </Typography>
              </Typography>
            }
          />
          <FormControlLabel
            value={InstagramOnboardingOptions.do_it_myself}
            control={<Radio />}
            label={
              <Typography component="div">
                Do It Myself{" "}
                <Typography
                  component="span"
                  color="textSecondary"
                  variant="body2"
                >
                  (free)
                </Typography>
              </Typography>
            }
          />
        </RadioGroup>
      </FormControl>

      <Grid container justifyContent="flex-end" sx={{ mt: 2 }}>
        <Button
          disableElevation
          disabled={!(option && option?.length > 0)}
          onClick={handleNext}
        >
          Next{" "}
          <Box
            component="i"
            className="fa-regular fa-arrow-right"
            sx={{ ml: 1 }}
          />
        </Button>
      </Grid>
    </>
  );
};

export default InstagramOnboardingPreference;
